import React from 'react';
import {useTranslation} from 'react-i18next';
import LanguageSelection from 'components/ModalSheets/LanguageSelection';
import {LanguageSelectionRef} from 'components/ModalSheets/LanguageSelection/LanguageSelection';
import {ContainerFooter, StyledButton} from '../styled';

function Footer() {
  const {t} = useTranslation();
  const languageSelectionModalRef = React.useRef<LanguageSelectionRef>(null);

  return (
    <ContainerFooter>
      <StyledButton
        label={t('privacy_policy')}
        iconName="lockIcon"
        iconProps={{size: 16, position: 'left'}}
        to={t('guest_privacy_policy_link')}
        openNewTab
        link
      />
      <StyledButton
        label={t('language')}
        iconName="languageIcon"
        iconProps={{size: 16, position: 'left'}}
        onClick={() => languageSelectionModalRef?.current?.open()}
        link
      />
      <LanguageSelection ref={languageSelectionModalRef} />
    </ContainerFooter>
  );
}

export {Footer};
